import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nxt-test-auth0',
  templateUrl: './test-auth0.component.html',
  styleUrls: ['./test-auth0.component.scss'],
})
export class TestAuth0Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
